// extracted by mini-css-extract-plugin
var _1 = "InvitationSettings-module__formFields--YZhfA";
var _2 = "InvitationSettings-module__formFooter--Y3Go8";
export { _1 as "formFields", _2 as "formFooter" }
